<div class="container-flex">
  <div class="tabla-container">
    <app-tabla
      [totalCount]="totalCount"
      [datos]="logEvento"
      [columnas]="columnas"
      [name]="name"
      [pageSizeOptions]="helper.pageSizeOptions"
      [(query)]="query"
      (queryChange)="listar()"
      [paginatorArriba]="false"
      [filtros]="filtros"
      [emptyState]="{ title: 'Todavía no hay mensajes LoRaWAN de este equipo' }"
    ></app-tabla>
  </div>
</div>
